import Login from './Login';

export default Login;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Login/index.ts